/* eslint-disable complexity */
import * as R from 'ramda'

export function addPollVote(state, action) {
  const { optionId, voteId, userId } = action.payload

  const prevVotes = R.pathOr([], [optionId, ':poll-option/voters'], state)

  return R.mergeDeepRight(state, {
    [optionId]: {
      ':poll-option/voters': [...prevVotes, voteId]
    },
    [voteId]: {
      ':db/id': voteId,
      ':system/created-at': Date.now(),
      ':poll-voter/user': userId
    }
  })
}

export function retractPollVote(state, action) {
  const { optionId, voterId } = action.payload

  const prevVotes = R.pathOr([], [optionId, ':poll-option/voters'], state)

  return R.mergeDeepRight(state, {
    [optionId]: {
      ':poll-option/voters': R.without([voterId], prevVotes)
    }
  })
}

export function updatePointsLog(state, action) {
  const { postId, newEntry } = action.payload
  const prevPointsLog = R.path([postId, '@post/points-log'], state)
  const pointsGrantedId = newEntry[':db/id']

  const update = R.assocPath(
    [postId, '@post/points-log'],
    R.append(pointsGrantedId, prevPointsLog),
    state
  )
  return R.assoc(pointsGrantedId, newEntry, update)
}

export function removeDraftPost(state, action) {
  const { draftId, boardId } = action.payload

  return R.evolve(
    {
      [boardId]: {
        '@board/count-draft-posts': R.compose(R.max(0), R.dec),
        drafts: {
          '@totalCount': R.compose(R.max(0), R.dec),
          data: R.without([draftId])
        }
      }
    },
    state
  )
}

export function removePost(state, action) {
  const postId = action.payload
  return R.dissoc(postId, state)
}

export function updatePinnedPost(state, action) {
  const { postId, boardId } = action.payload
  return R.assocPath([boardId, '@board/pinned-to-top'], postId, state)
}
